module.exports = __webpack_public_path__ + "static/media/2.0bc5b943.jpg";